import { React } from "react";
import { StyledMenu } from "./Menu.styled";
import { Link } from "react-router-dom";
import { bool } from "prop-types";

function Menu({ setOpen, open }) {
  return (
    <StyledMenu open={open} onClick={()=> setOpen(!open)}>
      <Link to="/">
        <span role="img" aria-label="home">

        </span>
        Home
      </Link>
      <Link to="/about">
        <span role="img" aria-label="about me">

        </span>
        About me
      </Link>
      <Link to="/skills">
        <span role="img" aria-label="skills">

        </span>
        Skills
      </Link>
      <Link to="/projects">
        <span role="img" aria-label="projects">

        </span>
        Projects
      </Link>
      <Link to="/contact">
        <span role="img" aria-label="contact">

        </span>
        Contact
      </Link>
    </StyledMenu>
  );
}
Menu.propTypes = {
  open: bool.isRequired,
};

export default Menu;
